import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=1d553e55&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=ts&"
export * from "./Legend.vue?vue&type=script&lang=ts&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=1d553e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d553e55",
  null
  
)

export default component.exports